import { render, staticRenderFns } from "./TakeBonusPopup.vue?vue&type=template&id=c2bd003e&scoped=true"
import script from "./TakeBonusPopup.vue?vue&type=script&lang=js"
export * from "./TakeBonusPopup.vue?vue&type=script&lang=js"
import style0 from "./TakeBonusPopup.vue?vue&type=style&index=0&id=c2bd003e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bd003e",
  null
  
)

export default component.exports